const accsessLink = document.querySelector('#access-content-link');

if (accsessLink) {
	accsessLink.addEventListener('click', (event) => {
		event.preventDefault();
		const { target } = event;
		window.open(target.href);
		location.reload();
	})
}
